import { getScrollContainer } from '@theme/scroll-container';

const reviewLinkSelector = '[data-product-rating-reviews-link]';
const reviewSectionSelector = '#product-reviews-section, .product-reviews-section';

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const reviewLink = event.target.closest(reviewLinkSelector);
  if (!(reviewLink instanceof HTMLAnchorElement)) return;

  const reviewSection = document.querySelector(reviewSectionSelector);
  if (!(reviewSection instanceof HTMLElement)) return;

  event.preventDefault();

  const scrollContainer = getScrollContainer();
  const containerRect = scrollContainer.getBoundingClientRect();
  const sectionRect = reviewSection.getBoundingClientRect();
  const headerHeight = document.querySelector('#header-group')?.getBoundingClientRect().height ?? 0;
  const targetTop = scrollContainer.scrollTop + sectionRect.top - containerRect.top - headerHeight - 16;
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

  history.pushState(null, '', reviewLink.hash);
  scrollContainer.scrollTo({ top: Math.max(0, targetTop), behavior });
});
